import React, { useContext, useState } from 'react';
import { IonCol, IonContent, IonFooter, IonGrid, IonPage, IonRow, IonToolbar } from '@ionic/react';
import { Button, Modal, Subtitulo, TextLink } from 'app-principal-componentes-visuales';
import useHomeEffects from '../../hooks/useHomeEffects';
import { useHistory } from 'react-router';
import { updateSocioPrincipal } from '../../api/socioPrincipalService';
import SolicitarAsistencia from '../../components/Cards/SolicitarAsistencia/SolicitarAsistencia';
import TerminosYCondiciones from '../../components/Modals/TerminosYCondiciones/TerminosYCondiciones';
import AsistenciaMedicaSkeleton from '../../components/Skeletons/AsistenciaMedicaSkeleton/AsistenciaMedicaSkeleton';
import { AsistenciaMedicaContext } from '../../contexts/AsistenciaMedicaContext';
import { Socio } from '../../models/socioPrincipal.model';
import ErrorPage from '../ErrorPage/ErrorPage';
import { AsistenciaMedicaActionType } from '../../interfaces/global-state/asistencia.medica.action.type.enum';
import { HISTORIAL_ATENCIONES, HOME } from '../../utils/constants';
import ErrorReintentar from '../ErrorReintentar/ErrorReintentar';
import DeshabilitarAsistencia from '../DeshabilitarAsistencia/DeshabilitarAsistencia';
import SessionHeader from '../../components/Headers/SessionHeader/SessionHeader';
import Footer from '../../components/Footer/Footer';
import ContactanosModal from '../../components/Modals/Contactanos/ContactanosModal';
import './AsistenciaMedica.scss';

export const AsistenciaMedica = ({ history }: { [key: string]: any }) => {

    const historyNavigate = useHistory();
    const { useRequest, asistenciaMedica, dispatchAsistenciaMedica, isWeb } = useContext(AsistenciaMedicaContext);
    const { apiRequest } = useRequest();
    const { state }: any = historyNavigate.location;
    const [error, setError] = useState(false);
    const [showTerminosModal, setShowTerminosModal] = useState(false);
    const [showContactanosModal, setShowContactanosModal] = useState(false);
    const [socioPrincipal, setSocioPrincipal] = useState<any>(asistenciaMedica?.usuario);
    // El state llamarServicios hace referencia a los llamados de servicio en inicio, luego de verificar si se encuentra deshabilitado el modulo de ADS
    const [reintentarError, setReintentarError] = useState<boolean>(false);
    const { flags, deshabilitarModulos, setReintentarRequest } = useHomeEffects(state, socioPrincipal, setSocioPrincipal, reintentarError, setReintentarError, setError)
    const { skeletonSeguimiento, asistenciaSkeleton, deshabilitarAsistencia, requestServicio } = flags;

    const openModal = () => {
        setShowTerminosModal(!showTerminosModal);
    };

    const openModalContactanos = () => {
        setShowContactanosModal(!showContactanosModal);
    };

    /**
     * Encargado de realizar el update en la base de datos con el nuevo estado del socio al aceptar terminos y condiciones
     */
    const acceptTerminosYCondiciones = () => {
        setShowTerminosModal(!showTerminosModal);
        let socio: Socio = socioPrincipal;
        socio.terms = true;
        setSocioPrincipal(socio);
        updateSocioPrincipal(socioPrincipal, apiRequest)
            .then(() => {
                dispatchAsistenciaMedica({
                    type: AsistenciaMedicaActionType.aceptarTerminos
                })
            })
            .catch(error => {
                console.error(`ASIS-MED - Hubo un error al persistir el socio principal ${error}`);
                setError(true)
            });
    };

    const handleServiciosEnCurso = () => {
        let serviciosEnCurso = { serviciosEnCurso: asistenciaMedica?.asistenciasSolicitadas, isServicioEnCurso: true };
        history.push(HISTORIAL_ATENCIONES, serviciosEnCurso);
    }

    const handleCasosFinalizados = () => {
        history.push(HISTORIAL_ATENCIONES, {isServicioEnCurso: false});
    }

    if (asistenciaSkeleton || skeletonSeguimiento) {
        return <AsistenciaMedicaSkeleton />
    } else if (deshabilitarAsistencia) {
        return <DeshabilitarAsistencia usuario={asistenciaMedica?.usuario} deshabilitarModulos={deshabilitarModulos} isWeb={isWeb} />
    } else if (error) {
        return <ErrorPage setError={setError} />
    } else if (reintentarError) {
        return <ErrorReintentar isWeb={isWeb} setReintentarError={setReintentarError} setReintentarRequest={setReintentarRequest} />
    } else {
        return (
            <IonPage className="asistencia-medica">
                <IonContent>
                    <SessionHeader socioPrincipal={asistenciaMedica?.usuario} path={HOME} notCancel />
                    <IonGrid className="content__grid asistencia_content-container asis-home-container">
                        <div>
                            <IonRow>
                                <IonCol size="12">
                                    <SolicitarAsistencia
                                        socioPrincipal={socioPrincipal}
                                        requestServicioEnCurso={requestServicio}
                                        openModal={openModal}
                                        handleServiciosEnCurso={handleServiciosEnCurso}
                                    />
                                </IonCol>
                                <IonCol className="grid__col contacto-area" size="12">
                                    <Subtitulo titulo="Visualizá las asistencias finalizadas" />
                                    <Button className="button-link" asist btnLink label="Ver asistencias" arrow onClick={handleCasosFinalizados} />
                                </IonCol>
                                <IonCol className="grid__col contacto-area" size="12">
                                    <Subtitulo titulo="¿Necesitás contactarte con Urgencias?" />
                                    <Button className="button-link" asist btnLink label="Contactanos" contact onClick={openModalContactanos} />
                                </IonCol>
                            </IonRow>
                        </div>
                    </IonGrid>
                    <IonFooter className="ion-no-border">
                        <IonToolbar>
                            <TextLink
                                id="asistencia-medica-text-link-terminos-condiciones"
                                onClick={openModal}
                                texto="Ver T&eacute;rminos y condiciones"
                                className="footer-terminos-condiciones"
                            />
                        </IonToolbar>
                        <Footer />
                    </IonFooter>
                </IonContent>
                <Modal
                    className="modal_web-large"
                    hideCloseBtn={false}
                    //@ts-ignore
                    component={<TerminosYCondiciones onClickAccept={acceptTerminosYCondiciones} terminosAceptados={socioPrincipal?.terms} />}
                    setShowModal={setShowTerminosModal}
                    showModal={showTerminosModal}
                    id="terminos-y-condiciones-modal"
                />

                <Modal
                    className="modal_web"
                    hideCloseBtn={false}
                    //@ts-ignore
                    component={<ContactanosModal componente='modal-contactanos' />}
                    setShowModal={setShowContactanosModal}
                    showModal={showContactanosModal}
                    id="contactanos"
                />
            </IonPage>
        );
    }
}
